import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from "react";
import useHover from "hooks/useHover";
import { Typography, RaiseColors, makeStyles, useTheme } from "client/componentLibrary";
import { Tab as MuiTab } from "@mui/material";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      tabRoot: _defineProperty({
        padding: "0px",
        margin: "8px 16px",
        width: "initial",
        minWidth: "initial",
        minHeight: "18px",
        opacity: 1
      }, theme.breakpoints.up("laptop"), {
        marginLeft: "24px",
        marginRight: "24px"
      })
    };
  });
};
var Tab = function Tab(_ref) {
  var label = _ref.label,
    activeValue = _ref.activeValue,
    value = _ref.value,
    onChange = _ref.onChange;
  var classes = useStyles()();
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    hoverRef = _useHover2[0],
    isHoveringOverItem = _useHover2[1];
  var isSelected = activeValue === value;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(MuiTab, {
      ref: hoverRef,
      disableRipple: true,
      value: value,
      label: isSelected ? /*#__PURE__*/_jsx(Typography, {
        noWrap: true,
        variant: "paragraph_small",
        color: RaiseColors.space1400,
        children: label
      }) : /*#__PURE__*/_jsx(Typography, {
        noWrap: true,
        variant: "paragraph_small",
        color: isHoveringOverItem ? RaiseColors.black : RaiseColors.gray300,
        children: label
      }),
      classes: {
        root: classes.tabRoot
      },
      onChange: onChange
    })
  });
};
export default Tab;